import { render, staticRenderFns } from "./FaqStatic.vue?vue&type=template&id=83823630&"
import script from "./FaqStatic.vue?vue&type=script&lang=js&"
export * from "./FaqStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports